"use client";
import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {GuestValidationError} from "@/features/rental/guests/guests-stepper.model";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "../styles/guest-error-alert.scss";

interface GuestErrorAlertProps {
    errors: Array<GuestValidationError>;
}

export function GuestErrorAlert({errors}: GuestErrorAlertProps): JSX.Element | null {
    const {t} = useTranslation("validation");

    if (errors.length === 0) return null;

    return (
        <div className="guest-error-alert">
            <SmartImage src={assetPath("/images/icons/info.svg")} alt="Warning" width={24} height={24} className="guest-error-alert__icon" />
            <div className="guest-error-alert__content">
                <Typography as="div" size={14} weight={600} className="guest-error-alert__title">
                    {t("guestLimitExceeded")}
                </Typography>
                <ul className="guest-error-alert__list">
                    {errors.map((error, index) => (
                        <li key={index}>
                            <Typography as="span" size={12} weight={400} color="paragraph">
                                {t(error.key as Parameters<typeof t>[0], error.params)}
                            </Typography>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
